import { Outlet } from 'react-router-dom';

import { authRoutes } from './auth';
import { oauthRoutes } from './oauth';
import { Tour } from '../../components/Tour';
import { dashboardRoutes } from './dashboard';
import { HomeRedirect } from '../../components/HomeRedirect';

// The tour walks between shells, so it mounts above all of them and never remounts.
const RootLayout = () => (
  <>
    <Outlet />
    <Tour />
  </>
);

export const routesSection = [
  {
    element: <RootLayout />,
    children: [
      {
        path: '/',
        element: <HomeRedirect />,
      },
      ...authRoutes,
      ...oauthRoutes,
      ...dashboardRoutes,
      {
        path: '*',
        element: <HomeRedirect />,
      },
    ],
  },
];
